(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[405],{

/***/ 48312:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/",
      function () {
        return __webpack_require__(32427);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 41616:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ButtonClose_ButtonClose; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./src/components/ButtonClose/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: block;\n  width: ",
        "px;\n  height: ",
        "px;\n\n  &::before,\n  &::after {\n    content: ' ';\n    position: absolute;\n    left: ",
        "px;\n    height: ",
        "px;\n    width: 2px;\n    background-color: ",
        ";\n  }\n  &::before {\n    transform: rotate(45deg);\n  }\n  &::after {\n    transform: rotate(-45deg);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var ButtonClose = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-38fbfb6b-0"
})(_templateObject(), function(param) {
    var size = param.size;
    return size ? size : 23;
}, function(param) {
    var size = param.size;
    return size ? size : 23;
}, function(param) {
    var size = param.size;
    return size ? size / 2 : 11;
}, function(param) {
    var size = param.size;
    return size ? size - 1 : 22;
}, function(param) {
    var theme = param.theme, color = param.color;
    return color ? color : theme.colors.gray800;
});

;// CONCATENATED MODULE: ./src/components/ButtonClose/index.tsx




function ButtonClose_ButtonClose(_param) {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 22 : _size, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonClose, (0,_object_spread/* default */.Z)({
        color: color,
        size: size
    }, props));
};


/***/ }),

/***/ 43277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_CompanyLogo; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/types/actionStatus.ts
var ActionStatus = {
    INITIAL: "initial",
    REQUEST: "request",
    SUCCESS: "success",
    FAILURE: "failure"
};
/* harmony default export */ var actionStatus = (ActionStatus);

;// CONCATENATED MODULE: ./src/hooks/useImageLoading.tsx


/**
 * imageUrl 을 받아서 이미지 객체의 로딩 상태를 반환한다
 *
 * @param {string} imageUrl 이미지 url
 * @return {{status: ActionStatus}} image 로딩 상태를 담은 객체
 */ function useImageLoading(imageUrl) {
    var ref = (0,react.useState)({
        status: actionStatus.INITIAL
    }), image = ref[0], setImage = ref[1];
    (0,react.useEffect)(function() {
        var img = new Image();
        if (imageUrl) {
            setImage({
                status: actionStatus.REQUEST
            });
            img.src = imageUrl;
        }
        img.onload = function() {
            setImage({
                status: actionStatus.SUCCESS
            });
        };
        img.onerror = function() {
            setImage({
                status: actionStatus.FAILURE
            });
        };
    }, [
        imageUrl
    ]);
    return image;
}
/* harmony default export */ var hooks_useImageLoading = (useImageLoading);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./src/components/CompanyLogo/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        border: 1px solid ",
        ";\n      "
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        img {\n          object-fit: contain;\n          width: 100%;\n          height: 100%;\n        }\n      "
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    border-radius: 4px;\n    overflow: hidden;\n    width: 70px;\n    height: 70px;\n    ",
        ";\n\n    ",
        ";\n\n    ",
        ";\n  "
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var S = {
    Logo: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-eccbfe20-0"
    })(_templateObject2(), function(props) {
        return props.hasBorder && (0,styled_components_browser_esm/* css */.iv)(_templateObject(), function(param) {
            var theme = param.theme;
            return theme.colors.gray400;
        });
    }, function(props) {
        return props.logoCss && props.logoCss;
    }, function(props) {
        return props.hasLogo && (0,styled_components_browser_esm/* css */.iv)(_templateObject1());
    })
};

;// CONCATENATED MODULE: ./src/components/CompanyLogo/index.tsx



/**
 *
 * @param {
 * PK_NM_HASH: company hash값
 * hasBorder?: border 유무
 * logoCss?: image wrapper size와 image size를 작성해주세요.
 * }
 * @returns
 */ function CompanyLogo(param) {
    var PK_NM_HASH = param.PK_NM_HASH, _hasBorder = param.hasBorder, hasBorder = _hasBorder === void 0 ? true : _hasBorder, logoCss = param.logoCss, _alt = param.alt, alt = _alt === void 0 ? "company_logo" : _alt;
    var logo = "https://s3.ap-northeast-2.amazonaws.com/kreditjob-public/logo/".concat(PK_NM_HASH);
    var logoImg = hooks_useImageLoading(logo);
    if (!PK_NM_HASH) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(S.Logo, {
        hasLogo: logoImg.status === "success",
        hasBorder: hasBorder,
        logoCss: logoCss,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
            alt: alt,
            src: logo,
            width: 200,
            onError: function(e) {
                e.currentTarget.src = "https://static.wanted.co.kr/images/kj/default_company_logo.png";
            }
        })
    }, PK_NM_HASH);
}
/* harmony default export */ var components_CompanyLogo = (CompanyLogo);


/***/ }),

/***/ 85326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ GoogleAdsBanner; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/constant/env.ts
var env = __webpack_require__(34572);
// EXTERNAL MODULE: ./src/utils/lodash/isServer/index.ts
var isServer = __webpack_require__(48086);
;// CONCATENATED MODULE: ./src/components/GoogleAdsBanner/constants.ts
var BANNER_SIZE = {
    leaderBoard: {
        width: "728px",
        height: "90px"
    },
    mobileBanner: {
        width: "300px",
        height: "50px"
    },
    mediumRectangle: {
        width: "300px",
        height: "136px"
    }
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./src/components/GoogleAdsBanner/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ins {\n    display: inline-block;\n    width: 100%;\n    height: inherit;\n    border: 1px solid ",
        ";\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-8fa5767c-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray300;
});

;// CONCATENATED MODULE: ./src/components/GoogleAdsBanner/index.tsx









function GoogleAdsBanner(_param) {
    var bannerType = _param.bannerType, slotId = _param.slotId, props = (0,_object_without_properties/* default */.Z)(_param, [
        "bannerType",
        "slotId"
    ]);
    (0,react.useEffect)(function() {
        if (isServer/* isClient */.C && env/* SERVER_ENV */.Km === "production") {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        }
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        bannerType: bannerType
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ins", {
            className: "adsbygoogle",
            style: (0,_object_spread/* default */.Z)({
                display: "inline-block"
            }, BANNER_SIZE[bannerType]),
            "data-ad-client": "ca-pub-7810616757902075",
            "data-ad-slot": slotId
        })
    }));
};


/***/ }),

/***/ 28096:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ ChevronLeft; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14141);





function ChevronLeft(_param) {
    var _width = _param.width, width = _width === void 0 ? 8 : _width, _height = _param.height, height = _height === void 0 ? 13 : _height, color = _param.color, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "width",
        "height",
        "color"
    ]);
    var theme = (0,styled_components__WEBPACK_IMPORTED_MODULE_2__/* .useTheme */ .Fg)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: width,
        height: height,
        viewBox: "0 0 11 18",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M10.5917 2.225L9.10837 0.75L0.866699 9L9.1167 17.25L10.5917 15.775L3.8167 9L10.5917 2.225Z",
            fill: color !== null && color !== void 0 ? color : theme.colors.gray700
        })
    }));
};


/***/ }),

/***/ 78982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ Picture; },
  "Z": function() { return /* binding */ components_Image; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/utils/browser/getOptimizeSrc.ts
/**
 * 원티드 이미지 최적화 URL로 반환
 * @see https://wantedlab.atlassian.net/wiki/spaces/FE/pages/2464972903/CloudFront+Lambda+Function+URL+.
 *
 * @param src
 * @param width
 * @param quality
 * @returns
 */ function getOptimizeSrc(param) {
    var src = param.src, width = param.width, _quality = param.quality, quality = _quality === void 0 ? 75 : _quality;
    if (src.startsWith("/")) {
        return src;
    }
    return "https://image.wanted.co.kr/optimize?src=".concat(encodeURIComponent(src), "&w=").concat(width, "&q=").concat(quality <= 0 || quality > 100 ? 75 : quality);
}

;// CONCATENATED MODULE: ./src/components/Image/index.tsx




/**
 * 1. 이미지 리사이징을 해줍니다.
 * 2. 브라우저가 webp 지원하면 webp포맷으로 내려줍니다.
 * 참고:
 * 보안을 위해 white list로 domain 관리하고 있습니다.
 * white list에 등록되지 않은 domain으로 요청이 들어오면 요청은 응답 거부(400 error) 됩니다.
 * @link https://us-east-1.console.aws.amazon.com/cloudfront/v3/home?region=ap-northeast-2#/functions/image-reize-allow-domain
 * ---------------------------------------------------------------------------------------------------------------------------------
 * @param src 이미지 원본 URL
 * @param alt 이미지 대체 텍스트 값. SEO 에 영향을 주므로 이미지에 맞는 대체텍스트를 넣을 것을 지향합니다.
 * @param width 이미지 가로사이즈이며, 크기에 영향을 줍니다.
 * @param quality 리사이징시 이미지 품질을 나타내는 정수값 입니다. 최상의 품질은 100이며, 기본값은 75 입니다.
 * @see https://wantedlab.atlassian.net/wiki/spaces/FE/pages/2464972903/CloudFront+Lambda+Function+URL+.
 */ var Image = function(_param) {
    var src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, width = _param.width, _quality = _param.quality, quality = _quality === void 0 ? 75 : _quality, other = (0,_object_without_properties/* default */.Z)(_param, [
        "src",
        "alt",
        "width",
        "quality"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("img", (0,_object_spread/* default */.Z)({
        src: getOptimizeSrc({
            src: src,
            width: width,
            quality: quality
        }),
        alt: alt
    }, other));
};
function Picture(_param) {
    var mobile = _param.mobile, resolution2xSrc = _param.resolution2xSrc, src = _param.src, _alt = _param.alt, alt = _alt === void 0 ? "" : _alt, width = _param.width, _quality = _param.quality, quality = _quality === void 0 ? 75 : _quality, props = (0,_object_without_properties/* default */.Z)(_param, [
        "mobile",
        "resolution2xSrc",
        "src",
        "alt",
        "width",
        "quality"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
        children: [
            mobile && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                srcSet: "".concat(getOptimizeSrc({
                    src: mobile.src,
                    width: mobile.width,
                    quality: mobile.quality
                }), " 2x"),
                media: "(max-width: 767px)"
            }),
            resolution2xSrc && /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                srcSet: "".concat(getOptimizeSrc({
                    src: resolution2xSrc,
                    width: Number(width) * 2,
                    quality: quality
                }), " 2x")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Image, (0,_object_spread/* default */.Z)({
                src: src,
                width: width,
                quality: quality,
                alt: alt
            }, props))
        ]
    });
}
/* harmony default export */ var components_Image = (Image);


/***/ }),

/***/ 26224:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ RenderOnClientReady; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_Loading__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72688);
/* harmony import */ var _hooks_useMedia__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(12447);



function RenderOnClientReady(param) {
    var children = param.children;
    var isReady = (0,_hooks_useMedia__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)().isReady;
    if (!isReady) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Loading__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {});
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: children
    });
};


/***/ }),

/***/ 66185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(14141);
/* harmony import */ var _hooks_useMedia__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12447);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  position: relative;\n  display: flex;\n\n  ",
        "\n  & .tooltiptext {\n    line-height: 1.5;\n    visibility: hidden;\n    padding: 15px;\n    width: ",
        "px;\n    background-color: ",
        ";\n    color: ",
        ";\n    font-size: ",
        ";\n    font-weight: 500;\n    text-align: left;\n    border-radius: 4px;\n    z-index: 1;\n    position: absolute;\n    top: calc(100% + 12px);\n    right: -9px;\n    ",
        "\n\n    margin-left: -60px;\n    opacity: 0;\n    transition: opacity 0.3s;\n  }\n\n  & .tooltiptext::after {\n    content: '';\n    display: block;\n    position: absolute;\n\n    ",
        "\n    ",
        "\n\n    bottom: 100%;\n    width: 0;\n    height: 0;\n    border: 7px solid transparent;\n    border-bottom-color: ",
        ";\n  }\n\n  &:hover .tooltiptext {\n    visibility: visible;\n    opacity: 1;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}




function Tooltip(param) {
    var children = param.children, tooltipText = param.tooltipText, position = param.position, _width = param.width, width = _width === void 0 ? 282 : _width;
    var isMobile = (0,_hooks_useMedia__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)().isMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(TooltipWrapper, {
        width: width,
        position: position,
        isMobile: isMobile,
        role: "tooltip",
        children: [
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                className: "tooltiptext",
                dangerouslySetInnerHTML: {
                    __html: tooltipText
                }
            })
        ]
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (Tooltip);
var TooltipWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-45b8c054-0"
})(_templateObject(), function(props) {
    return props.isMobile && '\n    &:after {\n      content: "";\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, -50%);\n      width: 200%;\n      height: 200%;\n    }\n  ';
}, function(props) {
    return props.width;
}, function(props) {
    return props.theme.colors.magenta700;
}, function(props) {
    return props.theme.colors.white100;
}, function(props) {
    return props.theme.fontSize.C1;
}, function(props) {
    return props.position === "center" && "right: calc(50% - ".concat(props.width / 2 + 2, "px);");
}, function(props) {
    return props.position === "center" && "right : calc(50% - 7px);";
}, function(props) {
    return props.position === "right" && "right: 11px;";
}, function(props) {
    return props.theme.colors.magenta700;
});


/***/ }),

/***/ 62857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useIndustries; }
/* harmony export */ });
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3471);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _lib_api_fetch__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(45767);
/* harmony import */ var _queryKeys__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(24858);



function useIndustries() {
    return (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_2__.useQuery)([
        _queryKeys__WEBPACK_IMPORTED_MODULE_1__/* ["default"].industries */ .Z.industries
    ], function() {
        return (0,_lib_api_fetch__WEBPACK_IMPORTED_MODULE_0__/* .fetcher */ ._)("/api/industries");
    });
};


/***/ }),

/***/ 398:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useGetIndustryByCode; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _query_company_useIndustries__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(62857);


/**
 * 업종 코드로 업종 데이터를 반환
 * @returns { getIndustryByCode }
 */ function useGetIndustryByCode() {
    var ref = (0,_query_company_useIndustries__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(), industries = ref.data;
    var getIndustryByCode = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(code) {
        return industries === null || industries === void 0 ? void 0 : industries.find(function(industry) {
            return industry.code === code;
        });
    }, [
        industries
    ]);
    return {
        getIndustryByCode: getIndustryByCode
    };
};


/***/ }),

/***/ 41771:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ useRouterQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69396);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);




function useRouterQuery(key) {
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
    if (Array.isArray(key)) {
        return key.reduce(function(prev, curr) {
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, prev), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, curr, router.query[curr]));
        }, {});
    }
    return router === null || router === void 0 ? void 0 : router.query[key];
}


/***/ }),

/***/ 55153:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "LH": function() { return /* binding */ ellipsis; }
/* harmony export */ });
/* unused harmony exports multiEllipsis, nowrap */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(14141);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        "\n  ",
        "\n  white-space: unset;\n  display: -webkit-box;\n  -webkit-line-clamp: ",
        ";\n  -webkit-box-orient: vertical;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  white-space: nowrap;\n  flex-wrap: nowrap;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var ellipsis = function() {
    return (0,styled_components__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)(_templateObject());
};
var multiEllipsis = function() {
    var lines = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 2;
    return css(_templateObject1(), ellipsis(), lines);
};
var nowrap = function() {
    return css(_templateObject2());
};


/***/ }),

/***/ 32427:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ pages; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/RenderOnClient/index.tsx
var RenderOnClient = __webpack_require__(26224);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/hooks/useIntersectionObserver.tsx
var useIntersectionObserver = __webpack_require__(34527);
// EXTERNAL MODULE: ./src/hooks/useMedia.ts
var useMedia = __webpack_require__(12447);
// EXTERNAL MODULE: ./src/utils/common/thirdPartyEvent.ts
var thirdPartyEvent = __webpack_require__(44278);
;// CONCATENATED MODULE: ./src/features/home/constants.ts
var MENU_TYPE_OBJ = {
    DALIY_VIEW_RANK: "DALIY_VIEW_RANK",
    SALARY_RANK: "SALARY_RANK",
    PUBLIC_SALARY_RANK: "PUBLIC_SALARY_RANK",
    RECENT_SALARY_RANK: "RECENT_SALARY_RANK"
};

;// CONCATENATED MODULE: ./src/features/home/LNB/constants.ts

var LNB_LIST = [
    {
        id: MENU_TYPE_OBJ.DALIY_VIEW_RANK,
        text: "일간 조회수 TOP"
    },
    {
        id: MENU_TYPE_OBJ.SALARY_RANK,
        text: "전체 평균연봉 TOP"
    },
    {
        id: MENU_TYPE_OBJ.PUBLIC_SALARY_RANK,
        text: "공기업 평균연봉 TOP"
    },
    {
        id: MENU_TYPE_OBJ.RECENT_SALARY_RANK,
        text: "입사자 평균연봉 TOP"
    }, 
];

;// CONCATENATED MODULE: ./src/features/home/LNB/helper.ts

var getSelectedkMenu = function(menuType) {
    if (!menuType) return;
    return LNB_LIST.find(function(lnb) {
        return lnb.id === menuType;
    });
};

;// CONCATENATED MODULE: ./src/components/Icon/ArrowIcon.tsx


function ArrowIcon() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "5",
        height: "8",
        viewBox: "0 0 5 8",
        fill: "none",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1.71 7.28997L4.3 4.69997C4.69 4.30997 4.69 3.67997 4.3 3.28997L1.71 0.699971C1.08 0.0799712 0 0.519971 0 1.40997V6.57997C0 7.47997 1.08 7.91997 1.71 7.28997Z",
            fill: "white"
        })
    });
}
/* harmony default export */ var Icon_ArrowIcon = (ArrowIcon);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(14141);
;// CONCATENATED MODULE: ./src/features/home/LNB/Menu/style.ts

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  border: none;\n  outline: inherit;\n  display: block;\n  width: 190px;\n  margin: 0;\n  padding: 0;\n  border-radius: 5px;\n  font-size: ",
        ";\n  cursor: pointer;\n\n  ",
        "\n\n  & > div > span {\n    float: left;\n    display: block;\n  }\n\n  #inner {\n    transform: rotate(45deg);\n    width: 38px;\n    height: 38px;\n    top: 6px;\n    position: absolute;\n    border-radius: 5px;\n  }\n\n  #outer {\n    position: absolute;\n    width: 52px;\n    height: 52px;\n    right: -29px;\n  }\n\n  #lower {\n    width: 185px;\n    height: 50px;\n    position: relative;\n    display: flex;\n    margin-left: 20px;\n    align-items: center;\n  }\n\n  & > svg {\n    position: absolute;\n    right: 4.5px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  color: #fff;\n  font-weight: ",
        ";\n\n  #inner {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  color: ",
        ";\n\n  #inner {\n    background-color: ",
        ";\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}

var MenuWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-c69cc5e5-0"
})(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.fontSize.B3;
}, function(props) {
    return props.selected ? Focused : UnFocused;
});
var Focused = (0,styled_components_browser_esm/* css */.iv)(_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
}, function(param) {
    var theme = param.theme;
    return theme.fontWeight.bold;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
});
var UnFocused = (0,styled_components_browser_esm/* css */.iv)(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white100;
});

;// CONCATENATED MODULE: ./src/features/home/LNB/Menu/index.tsx




function Menu(param) {
    var menuType = param.menuType, children = param.children, selected = param.selected, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuWrapper, {
        onClick: function() {
            return onClick(menuType);
        },
        selected: selected,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "outer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    id: "inner"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                id: "lower",
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_ArrowIcon, {})
        ]
    });
}
/* harmony default export */ var LNB_Menu = (Menu);

;// CONCATENATED MODULE: ./src/features/home/LNB/style.ts

function style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  line-height: 1.5;\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  font-size: ",
        ";\n  text-align: left;\n  color: ",
        ";\n  line-height: 1.5;\n  padding: 10px 0 10px 20px;\n\n  ",
        " {\n    margin-left: 4px;\n  }\n"
    ]);
    style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 15px 0 15px 0;\n"
    ]);
    style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 210px;\n  flex: 0 0 210px;\n\n  & > div > ul {\n    margin-bottom: 5px;\n  }\n\n  ",
        " {\n    width: auto;\n  }\n\n  ",
        " {\n    width: auto;\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var CommingSoon = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-482ed91f-0"
})(style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.fontSize.C2;
}, function(param) {
    var theme = param.theme;
    return theme.fontWeight.bold;
}, function(param) {
    var theme = param.theme;
    return theme.colors.magenta700;
});
var PreparingMenu = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-482ed91f-1"
})(style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.fontSize.C1;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray600;
}, CommingSoon);
var Divider = styled_components_browser_esm/* default.hr.withConfig */.ZP.hr.withConfig({
    componentId: "sc-482ed91f-2"
})(style_templateObject2());
var LNBWrapper = styled_components_browser_esm/* default.nav.withConfig */.ZP.nav.withConfig({
    componentId: "sc-482ed91f-3"
})(_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.media.tablet;
});

// EXTERNAL MODULE: ./src/components/Text/helper.ts
var helper = __webpack_require__(24985);
;// CONCATENATED MODULE: ./src/features/home/LNB/Tabs/style.ts

function Tabs_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  position: relative;\n  width: 100%;\n  overflow: auto;\n  border-bottom: 1px solid ",
        ";\n\n  ",
        " {\n    width: calc(100% + 32px);\n    left: -16px;\n  }\n\n  ",
        " {\n    width: calc(100% + 64px);\n    left: -32px;\n  }\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n"
    ]);
    Tabs_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Tabs_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  height: 100%;\n"
    ]);
    Tabs_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Tabs_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      &::after {\n        content: '';\n        width: 100%;\n        height: 3px;\n        display: block;\n        position: absolute;\n        bottom: 0;\n        left: 0;\n        background: ",
        ";\n      }\n\n      ",
        " {\n        color: ",
        ";\n      }\n    "
    ]);
    Tabs_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  height: 55px;\n  margin-right: 32px;\n  white-space: nowrap;\n  ",
        ";\n\n  ",
        "\n\n  &:first-child {\n    margin-left: 32px;\n  }\n\n  ",
        " {\n    &:first-child {\n      margin-left: 16px;\n    }\n\n    &:last-child {\n      margin-right: 16px;\n    }\n  }\n"
    ]);
    style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var style_MenuWrapper = styled_components_browser_esm/* default.ul.withConfig */.ZP.ul.withConfig({
    componentId: "sc-c76eed7b-0"
})(Tabs_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.media.tablet;
});
var Anchor = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-c76eed7b-1"
})(Tabs_style_templateObject1());
var MenuItem = styled_components_browser_esm/* default.li.withConfig */.ZP.li.withConfig({
    componentId: "sc-c76eed7b-2"
})(style_templateObject3(), (0,helper/* getFontStyle */.p)("bold150_B2"), function(param) {
    var $selected = param.$selected;
    return $selected && (0,styled_components_browser_esm/* css */.iv)(Tabs_style_templateObject2(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta700;
    }, Anchor, function(param) {
        var theme = param.theme;
        return theme.colors.magenta700;
    });
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

;// CONCATENATED MODULE: ./src/features/home/LNB/Tabs/index.tsx



function Tabs(param) {
    var selectedMenuId = param.selectedMenuId, menuList = param.menuList, onClick = param.onClick;
    var wrapperRef = (0,react.useRef)(null);
    var handleClick = function(e, _selectedMenuId) {
        if (_selectedMenuId === selectedMenuId) {
            return;
        }
        var _currentTarget = e.currentTarget, offsetLeft = _currentTarget.offsetLeft, offsetWidth = _currentTarget.offsetWidth;
        if (wrapperRef.current) {
            var ref;
            var spacingForCenter = (((ref = wrapperRef.current) === null || ref === void 0 ? void 0 : ref.offsetWidth) - offsetWidth) / 2;
            wrapperRef.current.scrollTo({
                left: offsetLeft - spacingForCenter,
                behavior: "smooth"
            });
        }
        if (onClick) {
            onClick(_selectedMenuId);
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(style_MenuWrapper, {
        ref: wrapperRef,
        children: menuList.map(function(param) {
            var id = param.id, text = param.text;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem, {
                onClick: function(e) {
                    return handleClick(e, id);
                },
                $selected: selectedMenuId === id,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Anchor, {
                    children: text
                })
            }, id);
        })
    });
};

;// CONCATENATED MODULE: ./src/features/home/LNB/index.tsx










function LNB(param) {
    var selectedMenu = param.selectedMenu, setSelectedMenu = param.setSelectedMenu;
    var router = (0,next_router.useRouter)();
    var isDesktop = (0,useMedia/* default */.Z)().isDesktop;
    var onClickMenu = function(menuType) {
        var lnbMenu = getSelectedkMenu(menuType);
        (0,thirdPartyEvent/* setGtmDataLayer */.id)("theme__click", {
            theme: (lnbMenu === null || lnbMenu === void 0 ? void 0 : lnbMenu.text) || ""
        });
        setSelectedMenu(menuType || MENU_TYPE_OBJ.DALIY_VIEW_RANK);
        var params = new URLSearchParams({
            selectedMenu: menuType
        });
        router.replace({
            pathname: "/",
            search: params.toString()
        }, undefined, {
            scroll: false
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LNBWrapper, {
        children: isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                LNB_LIST.map(function(option) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(LNB_Menu, {
                        menuType: option.id,
                        onClick: onClickMenu,
                        selected: option.id === selectedMenu,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            "data-value": option.id,
                            children: option.text
                        })
                    }, option.id);
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Divider, {})
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Tabs, {
            selectedMenuId: selectedMenu,
            menuList: LNB_LIST,
            onClick: onClickMenu
        })
    });
}
/* harmony default export */ var home_LNB = (LNB);

// EXTERNAL MODULE: ./src/components/Icon/ChevronLeft.tsx
var ChevronLeft = __webpack_require__(28096);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./src/components/Icon/ChevronRight.tsx





function ChevronRight(_param) {
    var _width = _param.width, width = _width === void 0 ? 8 : _width, _height = _param.height, height = _height === void 0 ? 13 : _height, color = _param.color, props = (0,_object_without_properties/* default */.Z)(_param, [
        "width",
        "height",
        "color"
    ]);
    var theme = (0,styled_components_browser_esm/* useTheme */.Fg)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: width,
        height: height,
        viewBox: "0 0 8 13",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M1.99984 0.5L0.589844 1.91L5.16984 6.5L0.589844 11.09L1.99984 12.5L7.99984 6.5L1.99984 0.5Z",
            fill: color !== null && color !== void 0 ? color : theme.colors.gray700
        })
    }));
};

// EXTERNAL MODULE: ./src/utils/lodash/isServer/index.ts
var isServer = __webpack_require__(48086);
;// CONCATENATED MODULE: ./src/features/home/LNB/SubCategoryTabs/style.ts

function SubCategoryTabs_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 100%;\n  margin-top: 12px;\n\n  ",
        " {\n    width: calc(100% + 32px);\n    left: -16px;\n  }\n\n  ",
        " {\n    width: calc(100% + 64px);\n    left: -32px;\n  }\n"
    ]);
    SubCategoryTabs_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SubCategoryTabs_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n\n  position: relative;\n  width: 100%;\n  overflow: auto;\n\n  &::-webkit-scrollbar {\n    display: none;\n  }\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n"
    ]);
    SubCategoryTabs_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SubCategoryTabs_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      background-color: ",
        ";\n      border-color: ",
        ";\n      color: ",
        ";\n    "
    ]);
    SubCategoryTabs_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SubCategoryTabs_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  padding: 8px 16px;\n  color: ",
        ";\n  margin-right: 12px;\n  border-radius: 25px;\n  border: 1px solid ",
        ";\n  white-space: nowrap;\n  user-select: none;\n  ",
        "\n\n  ",
        "\n\n  &:last-of-type {\n    margin-right: 0;\n  }\n\n  ",
        " {\n    &:first-of-type {\n      margin-left: 16px;\n    }\n\n    &:last-of-type {\n      margin-right: 16px;\n    }\n  }\n\n  ",
        " {\n    &:first-of-type {\n      margin-left: 32px;\n    }\n\n    &:last-of-type {\n      margin-right: 32px;\n    }\n  }\n"
    ]);
    SubCategoryTabs_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 0 0 1px;\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: absolute;\n  top: 0;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  background-color: #fff;\n  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.15);\n  z-index: 10;\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  left: 0;\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  right: 0;\n"
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var SubCategoryTabs_style_MenuWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9eeed32-0"
})(SubCategoryTabs_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.media.tablet;
});
var MenuList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9eeed32-1"
})(SubCategoryTabs_style_templateObject1());
var style_MenuItem = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-e9eeed32-2"
})(SubCategoryTabs_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, (0,helper/* getFontStyle */.p)("midium150_B3"), function(param) {
    var $selected = param.$selected;
    return $selected && (0,styled_components_browser_esm/* css */.iv)(SubCategoryTabs_style_templateObject2(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta100;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.magenta700;
    }, function(param) {
        var theme = param.theme;
        return theme.colors.magenta700;
    });
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.media.tablet;
});
var IntersectionHolder = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-e9eeed32-3"
})(_templateObject4());
var Arrow = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-e9eeed32-4"
})(_templateObject5());
var ArrowPrev = (0,styled_components_browser_esm/* default */.ZP)(Arrow).withConfig({
    componentId: "sc-e9eeed32-5"
})(_templateObject6());
var ArrowNext = (0,styled_components_browser_esm/* default */.ZP)(Arrow).withConfig({
    componentId: "sc-e9eeed32-6"
})(_templateObject7());

;// CONCATENATED MODULE: ./src/features/home/LNB/SubCategoryTabs/index.tsx










function SubCategoryTabs(param) {
    var selectedMenuId = param.selectedMenuId, menuList = param.menuList, onClick = param.onClick;
    var router = (0,next_router.useRouter)();
    var isDesktop = (0,useMedia/* default */.Z)().isDesktop;
    var menuListRef = (0,react.useRef)(null);
    var startPositionRef = (0,react.useRef)(null);
    var endPositionRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(), displayArrowPrev = ref[0], setDisplayArrowPrev = ref[1];
    var ref1 = (0,react.useState)(), displayArrowNext = ref1[0], setDisplayArrowNext = ref1[1];
    var startPositionEntry = (0,useIntersectionObserver/* default */.Z)(startPositionRef, {
        root: menuListRef.current
    });
    var endPositionEntry = (0,useIntersectionObserver/* default */.Z)(endPositionRef, {
        root: menuListRef.current
    });
    var handleClick = function(_selectedMenu) {
        if (_selectedMenu.code === selectedMenuId) {
            return;
        }
        (0,thirdPartyEvent/* setGtmDataLayer */.id)("home__companyIndustry__click", {
            companyIndustry: _selectedMenu.name
        });
        if (onClick) {
            onClick(_selectedMenu.code);
        }
    };
    var handleAnimateScroll = function(elem) {
        var offsetLeft = elem.offsetLeft, offsetWidth = elem.offsetWidth;
        if (menuListRef.current) {
            var ref;
            var spacingForCenter = (((ref = menuListRef.current) === null || ref === void 0 ? void 0 : ref.offsetWidth) - offsetWidth) / 2;
            menuListRef.current.scrollTo({
                left: offsetLeft - spacingForCenter,
                behavior: "smooth"
            });
        }
    };
    var handleClickArrow = function(direction) {
        if (menuListRef.current) {
            var target = menuListRef.current;
            var moveValue = direction === "next" ? 300 : -300;
            target.scrollTo({
                left: target.scrollLeft + moveValue,
                behavior: "smooth"
            });
        }
    };
    (0,react.useEffect)(function() {
        setDisplayArrowPrev(isDesktop && !(startPositionEntry === null || startPositionEntry === void 0 ? void 0 : startPositionEntry.isIntersecting));
        setDisplayArrowNext(isDesktop && !(endPositionEntry === null || endPositionEntry === void 0 ? void 0 : endPositionEntry.isIntersecting));
    }, [
        isDesktop,
        startPositionEntry,
        endPositionEntry
    ]);
    (0,react.useEffect)(function() {
        if (menuListRef.current) {
            menuListRef.current.scrollTo({
                left: 0
            });
        }
    }, [
        menuList
    ]);
    (0,react.useEffect)(function() {
        if (router.query && isServer/* isClient */.C) {
            var elem = document.querySelector("#sub-category-id-".concat(router.query.subCategory));
            if (elem) {
                handleAnimateScroll(elem);
            }
        }
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SubCategoryTabs_style_MenuWrapper, {
        children: [
            displayArrowPrev && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowPrev, {
                onClick: function() {
                    return handleClickArrow("prev");
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronLeft/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(MenuList, {
                ref: menuListRef,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IntersectionHolder, {
                        ref: startPositionRef
                    }),
                    menuList.map(function(item) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(style_MenuItem, {
                            onClick: function(e) {
                                return handleClick(item);
                            },
                            id: "sub-category-id-".concat(item.code),
                            $selected: selectedMenuId === item.code,
                            children: item.name
                        }, item.code);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(IntersectionHolder, {
                        ref: endPositionRef
                    })
                ]
            }),
            displayArrowNext && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArrowNext, {
                onClick: function() {
                    return handleClickArrow("next");
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRight, {})
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/components/common/Tooltip/index.tsx
var Tooltip = __webpack_require__(66185);
;// CONCATENATED MODULE: ./src/components/Icon/Info.tsx




function Info(_param) {
    var _fill = _param.fill, fill = _fill === void 0 ? "#7D7D7D" : _fill, props = (0,_object_without_properties/* default */.Z)(_param, [
        "fill"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 20 20",
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M9 5H11V7H9V5ZM9 9H11V15H9V9ZM10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM10 18C5.59 18 2 14.41 2 10C2 5.59 5.59 2 10 2C14.41 2 18 5.59 18 10C18 14.41 14.41 18 10 18Z",
            fill: fill
        })
    }));
}
/* harmony default export */ var Icon_Info = (Info);

// EXTERNAL MODULE: ./node_modules/@tanstack/react-query/build/umd/index.production.js
var index_production = __webpack_require__(3471);
// EXTERNAL MODULE: ./node_modules/query-string/index.js + 4 modules
var query_string = __webpack_require__(54887);
// EXTERNAL MODULE: ./src/lib/api/fetch.ts
var fetch = __webpack_require__(45767);
// EXTERNAL MODULE: ./src/hooks/query/queryKeys.ts
var queryKeys = __webpack_require__(24858);
;// CONCATENATED MODULE: ./src/hooks/query/home/useRanking.tsx




var rankingUrlList = {
    DALIY_VIEW_RANK: "/api/main/viewsRank",
    SALARY_RANK: "/api/main/salaryRank",
    PUBLIC_SALARY_RANK: "/api/main/salaryRank",
    RECENT_SALARY_RANK: "/api/main/salaryRank"
};
var CHUNK_SIZE = 10;
var LIST_LIMIT = 30;
var convertData = function(data) {
    var rankingData = (data || []).slice(0, LIST_LIMIT);
    var mappedRankingData = rankingData.map(function(e, i) {
        return i % CHUNK_SIZE === 0 ? rankingData.slice(i, i + CHUNK_SIZE) : null;
    }).filter(function(e) {
        return e;
    });
    return mappedRankingData;
};
function useGetRanking(selectedMenu, sectionCode) {
    var queryParams = {};
    if ((selectedMenu === "DALIY_VIEW_RANK" || selectedMenu === "SALARY_RANK") && sectionCode && sectionCode !== "TOTAL") {
        queryParams["sectionCode"] = sectionCode;
    }
    if (selectedMenu === "PUBLIC_SALARY_RANK") {
        queryParams["category"] = "PUBLIC";
    }
    if (selectedMenu === "RECENT_SALARY_RANK") {
        queryParams["category"] = "HIRED";
    }
    var response = (0,index_production.useQuery)([
        queryKeys/* default.rankingList */.Z.rankingList,
        selectedMenu,
        sectionCode
    ], function() {
        return (0,fetch/* fetcher */._)("".concat(rankingUrlList[selectedMenu], "?").concat(query_string/* default.stringify */.Z.stringify(queryParams)));
    }, {
        enabled: !!selectedMenu
    });
    var data = response.data, status = response.status;
    return {
        status: status,
        data: data,
        mappedData: convertData(data === null || data === void 0 ? void 0 : data.data)
    };
};

// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./src/utils/date/formattedMDTimeDate.ts
// @ts-ignore

// TODO:: util 로 옮기기
var formattedMDTimeDate = function(date) {
    if (!date) return "";
    var day = dayjs_min_default()(date).format("YYYY-M-DD");
    var dateArr = day.split("-");
    var time = dayjs_min_default()(new Date(date)).format("HH:mm");
    return "".concat(dateArr[1], "월 ").concat(dateArr[2], "일 ").concat(time);
};
/* harmony default export */ var date_formattedMDTimeDate = (formattedMDTimeDate);

;// CONCATENATED MODULE: ./src/utils/date/index.ts


// EXTERNAL MODULE: ./src/utils/locationFormat/index.ts + 1 modules
var locationFormat = __webpack_require__(23133);
;// CONCATENATED MODULE: ./src/utils/index.ts



;// CONCATENATED MODULE: ./src/hooks/query/home/useIndustriesByCategory.ts



/**
 * 카테고리(eg. 일반 조회수 TOP)별 산업군 리스트
 * @param category
 * @returns
 * @link https://dev.kreditjob.com/api/static/index.html#/Main%20Page%20API/MainController_getSectionList
 */ function useIndustriesByCategoryQuery(category) {
    return (0,index_production.useQuery)([
        queryKeys/* default.industriesByCategory */.Z.industriesByCategory,
        category
    ], function() {
        return (0,fetch/* fetcher */._)("/api/main/section?category=".concat(category));
    }, {
        enabled: !!category
    });
};

// EXTERNAL MODULE: ./src/hooks/useGetIndustryByCode.ts
var useGetIndustryByCode = __webpack_require__(398);
;// CONCATENATED MODULE: ./src/features/home/Ranking/helper.ts
function getIndustryCategory(queryParam) {
    if (queryParam === "DALIY_VIEW_RANK") {
        return "VIEWS";
    }
    if (queryParam === "SALARY_RANK") {
        return "SALARY";
    }
}

;// CONCATENATED MODULE: ./src/features/home/Ranking/hooks.ts





function useGetCatetoryIndustriesMenu(selectedMenu) {
    var ref = (0,react.useState)([]), industriesMenu = ref[0], setIndustriesMenu = ref[1];
    var getIndustryByCode = (0,useGetIndustryByCode/* default */.Z)().getIndustryByCode;
    var ref1 = useIndustriesByCategoryQuery(getIndustryCategory(selectedMenu)), industriesByCategory = ref1.data;
    (0,react.useEffect)(function() {
        if (!getIndustryCategory(selectedMenu)) {
            setIndustriesMenu([]);
        }
    }, [
        selectedMenu
    ]);
    (0,react.useEffect)(function() {
        if (industriesByCategory) {
            var newArray = [
                {
                    name: "전체",
                    code: "TOTAL"
                }, 
            ].concat((0,_to_consumable_array/* default */.Z)(industriesByCategory === null || industriesByCategory === void 0 ? void 0 : industriesByCategory.map(function(industryCode) {
                return getIndustryByCode(industryCode);
            })));
            setIndustriesMenu(newArray);
        }
    }, [
        industriesByCategory
    ]);
    return industriesMenu;
}

// EXTERNAL MODULE: ./src/components/CompanyLogo/index.tsx + 3 modules
var CompanyLogo = __webpack_require__(43277);
// EXTERNAL MODULE: ./src/utils/formatted/number.ts
var number = __webpack_require__(23230);
;// CONCATENATED MODULE: ./src/features/home/Ranking/RankingCard/constants.ts
var COMPANY_TYPE = {
    KOSPI: "코스피",
    KOSDAQ: "코스닥",
    KONEX: "코넥스",
    CORP: "일반기업",
    DEFAULT: "공공기관"
};

;// CONCATENATED MODULE: ./src/features/home/Ranking/RankingCard/style.ts

function RankingCard_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 4px;\n  width: 38px;\n  height: 38px;\n\n  text-align: center;\n  background: ",
        ";\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n"
    ]);
    RankingCard_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RankingCard_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 70px;\n  height: 28px;\n\n  & > img {\n    width: 40px;\n    height: 25px;\n  }\n\n  margin-left: 30px;\n\n  ",
        " {\n    width: 37.5px;\n    height: 15px;\n    margin-left: 10px;\n\n    & > img {\n      width: 25px;\n      height: 15px;\n    }\n  }\n"
    ]);
    RankingCard_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RankingCard_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n"
    ]);
    RankingCard_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RankingCard_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1;\n  font-weight: ",
        ";\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n\n  & > p {\n    text-align: left;\n    text-overflow: ellipsis;\n    overflow: hidden;\n  }\n\n  & > p:first-of-type {\n    font-size: ",
        ";\n    line-height: 1.5;\n  }\n\n  & > p:nth-of-type(2) {\n    font-size: ",
        ";\n    color: ",
        ";\n    line-height: 1.5;\n\n    & > ",
        " {\n      margin-left: 5px;\n    }\n  }\n"
    ]);
    RankingCard_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n\n  ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  & > a {\n    display: flex;\n    align-items: center;\n    justify-content: left;\n    cursor: pointer;\n\n    & > ",
        " {\n      margin: 12px 0 10px 12px;\n    }\n\n    & > ",
        " {\n      margin-left: 30px;\n      ",
        " {\n        margin-left: 10px;\n      }\n    }\n\n    & > ",
        " {\n      margin: auto 19px auto 4px;\n      ",
        " {\n        margin: auto 15px auto 5px;\n      }\n    }\n  }\n\n  &:not(:last-child) {\n    border-bottom: 1px solid #ebebeb;\n  }\n"
    ]);
    style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

var Rank = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b5a37042-0"
})(RankingCard_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray300;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.B2;
}, function(param) {
    var theme = param.theme;
    return theme.fontWeight.bold;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
});
var logoCss = (0,styled_components_browser_esm/* css */.iv)(RankingCard_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var Tag = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-b5a37042-1"
})(RankingCard_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.fontSize.C1;
}, function(param) {
    var theme = param.theme;
    return theme.colors.greymint300;
}, function(param) {
    var theme = param.theme;
    return theme.fontWeight.bold;
});
var CompanyInfo = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-b5a37042-2"
})(RankingCard_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.fontWeight.normal;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.B3;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.C1;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray700;
}, Tag);
var RankData = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-b5a37042-3"
})(style_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.fontWeight.normal;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.B3;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.C1;
});
var RankingCardWrapper = styled_components_browser_esm/* default.article.withConfig */.ZP.article.withConfig({
    componentId: "sc-b5a37042-4"
})(style_templateObject5(), Rank, CompanyInfo, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, RankData, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

;// CONCATENATED MODULE: ./src/features/home/Ranking/RankingCard/index.tsx








function RankingCard(param) {
    var PK_NM_HASH = param.PK_NM_HASH, rank = param.rank, name = param.name, location = param.location, category = param.category, salary = param.salary, logo = param.logo, locationCode = param.locationCode, eventTitle = param.eventTitle;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingCardWrapper, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: "/company/".concat(PK_NM_HASH),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                "data-attribute-id": "home__company__click",
                "data-company-name": name,
                "data-company-type": COMPANY_TYPE[category] || COMPANY_TYPE.DEFAULT,
                "data-rank": rank,
                "data-theme": eventTitle,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Rank, {
                        children: rank
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CompanyLogo/* default */.Z, {
                        PK_NM_HASH: PK_NM_HASH,
                        logoCss: logoCss,
                        hasBorder: false
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CompanyInfo, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: name
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                children: [
                                    (0,locationFormat/* getShortenedAddress */.r)(locationCode || "", location),
                                    !!category && category !== "CORP" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tag, {
                                        children: COMPANY_TYPE[category] || COMPANY_TYPE.DEFAULT
                                    })
                                ]
                            })
                        ]
                    }),
                    !!salary && /*#__PURE__*/ (0,jsx_runtime.jsxs)(RankData, {
                        children: [
                            "평균 ",
                            (0,number/* millionFormattedtoString */.X6)(salary),
                            "만원"
                        ]
                    })
                ]
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/features/home/Ranking/SkeletonRankingCard/style.ts

function SkeletonRankingCard_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  align-items: center;\n  justify-content: left;\n  height: 60px;\n  padding: 10px;\n\n  .rank {\n    border-radius: 4px;\n    width: 38px;\n    height: 38px;\n    background: ",
        ";\n  }\n\n  .logo {\n    width: 40px;\n    height: 26px;\n    background: ",
        ";\n    margin-left: 45px;\n  }\n\n  .companyInfo {\n    display: flex;\n    flex: 1;\n    flex-direction: column;\n\n    & > p {\n      background: ",
        ";\n      height: 16px;\n      margin-left: 44px;\n    }\n\n    & > p:first-of-type {\n      width: 87px;\n      margin-bottom: 3px;\n    }\n\n    & > p:nth-of-type(2) {\n      width: 113px;\n    }\n  }\n\n  .data {\n    background: ",
        ";\n    width: 87px;\n    height: 16px;\n  }\n\n  &:not(:last-child) {\n    border-bottom: 1px solid #ebebeb;\n  }\n\n  @media screen and (max-width: 1200px) {\n    .logo {\n      width: 28px;\n      height: 17px;\n      margin-left: 15px;\n    }\n\n    .companyInfo {\n      display: flex;\n      flex: 1;\n      flex-direction: column;\n\n      & > p {\n        margin-left: 18px;\n      }\n\n      & > p:first-of-type {\n        margin-bottom: 3px;\n      }\n    }\n  }\n"
    ]);
    SkeletonRankingCard_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var SkelletonCard = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-220b05bb-0"
})(SkeletonRankingCard_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.gray300;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray300;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray300;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray300;
});

;// CONCATENATED MODULE: ./src/features/home/Ranking/SkeletonRankingCard/index.tsx


function SkeletonRankingCard() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SkelletonCard, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "rank"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "logo"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "companyInfo",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {})
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "data"
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/GoogleAdsBanner/index.tsx + 2 modules
var GoogleAdsBanner = __webpack_require__(85326);
;// CONCATENATED MODULE: ./src/features/home/Ranking/style.ts

function Ranking_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 15px 0 15px -38px;\n\n  ",
        " {\n    margin: 15px auto;\n  }\n\n  ",
        " {\n    margin: 15px auto;\n  }\n"
    ]);
    Ranking_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function Ranking_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: block;\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  margin: 0;\n  padding: 0;\n  font-size: ",
        ";\n  text-align: left;\n  flex: 1;\n"
    ]);
    Ranking_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function Ranking_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  justify-content: center;\n  margin-top: 16px;\n\n  ",
        " {\n    position: absolute;\n    top: 0;\n    right: 0;\n    margin-top: 0;\n  }\n"
    ]);
    Ranking_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function Ranking_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  color: ",
        ";\n  display: flex;\n  align-items: center;\n  height: 25px;\n  padding: 0 4px;\n  background: ",
        ";\n  border-radius: 4px;\n\n  & svg {\n    margin-left: 7px;\n  }\n"
    ]);
    Ranking_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function Ranking_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: 1px solid #ebebeb;\n  border-radius: 4px;\n"
    ]);
    Ranking_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function Ranking_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n"
    ]);
    Ranking_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: inline-block;\n  background: ",
        ";\n  border: 1px solid ",
        ";\n  box-sizing: border-box;\n  border-radius: 100px;\n\n  font-size: ",
        ";\n  font-weight: ",
        ";\n  color: ",
        ";\n  padding: 14px 40px;\n"
    ]);
    style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function style_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  width: 652px;\n  margin: 10px auto 0;\n  min-height: 300px;\n\n  & > ",
        " {\n    margin-top: 30px;\n  }\n\n  ",
        " {\n    width: 100%;\n    margin-top: 0;\n  }\n"
    ]);
    style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}


var style_GoogleAdsBanner = (0,styled_components_browser_esm/* default */.ZP)(GoogleAdsBanner/* default */.Z).withConfig({
    componentId: "sc-bf4bcc68-0"
})(Ranking_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var Title = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-bf4bcc68-1"
})(Ranking_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.fontWeight.bold;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.H4;
}, function(props) {
    return props.theme.fontSize.H4;
});
var UpdateDateWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bf4bcc68-2"
})(Ranking_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.pc;
});
var UpdateDate = styled_components_browser_esm/* default.span.withConfig */.ZP.span.withConfig({
    componentId: "sc-bf4bcc68-3"
})(Ranking_style_templateObject3(), function(props) {
    return props.theme.fontWeight.normal;
}, function(props) {
    return props.theme.fontSize.B3;
}, function(props) {
    return props.theme.colors.gray700;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray300;
});
var RankingCardGroup = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-bf4bcc68-4"
})(Ranking_style_templateObject4());
var RankingBody = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-bf4bcc68-5"
})(Ranking_style_templateObject5());
var ShowMore = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-bf4bcc68-6"
})(style_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.B2;
}, function(param) {
    var theme = param.theme;
    return theme.fontWeight.bold;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray800;
});
var RankingWrapper = styled_components_browser_esm/* default.main.withConfig */.ZP.main.withConfig({
    componentId: "sc-bf4bcc68-7"
})(style_templateObject7(), ShowMore, function(param) {
    var theme = param.theme;
    return theme.media.with("tablet", "mobile");
});

;// CONCATENATED MODULE: ./src/features/home/Ranking/index.tsx



















function Ranking(param) {
    var selectedMenu = param.selectedMenu;
    var router = (0,next_router.useRouter)();
    var ref = (0,useMedia/* default */.Z)(), isMobile = ref.isMobile, isDesktop = ref.isDesktop;
    var ref1 = (0,react.useState)("TOTAL"), selectedSubCategoryId = ref1[0], setSelectedSubCategoryId = ref1[1];
    var industriesMenu = useGetCatetoryIndustriesMenu(selectedMenu);
    var handleClickSubCategory = function(subCategoryId) {
        var params = new URLSearchParams({
            selectedMenu: selectedMenu,
            subCategory: subCategoryId
        });
        setSelectedSubCategoryId(subCategoryId);
        router.replace({
            pathname: "/",
            search: params.toString()
        }, undefined, {
            scroll: false
        });
    };
    var ref2 = useGetRanking(selectedMenu, selectedSubCategoryId), tmp = ref2.mappedData, mappedRankingData = tmp === void 0 ? [] : tmp, status = ref2.status, selectedRanking = ref2.data;
    var text = (0,react.useMemo)(function() {
        return LNB_LIST.find(function(lnb) {
            return lnb.id === selectedMenu;
        }) || {
            text: ""
        };
    }, [
        selectedMenu
    ]).text;
    (0,react.useEffect)(function() {
        var ref;
        setSelectedSubCategoryId((ref = router.query.subCategory) !== null && ref !== void 0 ? ref : "TOTAL");
    }, [
        router.asPath
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RankingWrapper, {
        children: [
            isDesktop && /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: text
            }),
            isDesktop && industriesMenu && industriesMenu.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategoryTabs, {
                selectedMenuId: selectedSubCategoryId,
                menuList: industriesMenu,
                onClick: handleClickSubCategory
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(UpdateDateWrapper, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(UpdateDate, {
                    children: [
                        selectedRanking && status === "success" && "".concat(date_formattedMDTimeDate(selectedRanking.version && new Date(selectedRanking.version)), " 기준"),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.Z, {
                            position: isMobile ? "center" : "right",
                            tooltipText: "국민연금, 금감원, 알리오, 클린아이 등의 데이터를 기반으로 추정된 값입니다. 참고 자료로만 활용하시길 바랍니다.",
                            width: isMobile ? 262 : 282,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_Info, {})
                        })
                    ]
                })
            }),
            selectedRanking && selectedRanking.data && selectedRanking.data.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingBody, {
                children: mappedRankingData.map(function(group, groupIndex) {
                    if (!group) return null;
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingCardGroup, {
                                children: group.map(function(company, rankIndex) {
                                    return /*#__PURE__*/ (0,react.createElement)(RankingCard, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, company), {
                                        key: "salary_agv_ranking_".concat(company.PK_NM_HASH),
                                        eventTitle: text
                                    }));
                                })
                            }),
                            groupIndex < 2 && /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                "data-attribute-id": "home__banner__click",
                                "data-banner-type": "ads",
                                "data-banner-location": "inner-".concat(groupIndex + 1),
                                children: isMobile ? /*#__PURE__*/ (0,jsx_runtime.jsx)(style_GoogleAdsBanner, {
                                    bannerType: "mobileBanner",
                                    slotId: "8076432031"
                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(style_GoogleAdsBanner, {
                                    bannerType: "leaderBoard",
                                    slotId: "8397610632"
                                })
                            })
                        ]
                    }, "ranking_group_".concat(groupIndex));
                })
            }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(RankingBody, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingCardGroup, {
                        children: (0,_to_consumable_array/* default */.Z)(Array(10)).map(function(e, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonRankingCard, {}, "skel_group1_".concat(index));
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingCardGroup, {
                        children: (0,_to_consumable_array/* default */.Z)(Array(10)).map(function(e, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(SkeletonRankingCard, {}, "skel_group2_".concat(index));
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                href: "/dashboard",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ShowMore, {
                    "data-attribute-id": "cta__click",
                    "data-cta-type": "industryMore",
                    children: "산업군별 더보기 +"
                })
            })
        ]
    });
}
/* harmony default export */ var home_Ranking = (/*#__PURE__*/react.memo(Ranking));

// EXTERNAL MODULE: ./src/hooks/useRouterQuery.ts
var useRouterQuery = __webpack_require__(41771);
;// CONCATENATED MODULE: ./src/features/home/RankingContents/hooks.ts

function useGetMenuByParams() {
    return (0,useRouterQuery/* useRouterQuery */.o)("selectedMenu");
}

;// CONCATENATED MODULE: ./src/features/home/RankingContents/style.ts

function RankingContents_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        padding-top: 104px;\n      "
    ]);
    RankingContents_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RankingContents_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n\n  ",
        " {\n    position: relative;\n    display: block;\n    padding-top: 56px;\n\n    ",
        "\n  }\n\n  ",
        " {\n    padding-left: 16px;\n    padding-right: 16px;\n  }\n\n  ",
        " {\n    padding-left: 32px;\n    padding-right: 32px;\n  }\n"
    ]);
    RankingContents_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RankingContents_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    margin-right: 30px;\n  }\n"
    ]);
    RankingContents_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RankingContents_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n        position: fixed;\n        top: 55px;\n        left: 0;\n        z-index: 10;\n        background-color: #fff;\n      "
    ]);
    RankingContents_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RankingContents_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    width: 100%;\n    position: absolute;\n    top: 0;\n    left: 0;\n\n    ",
        "\n  }\n\n  ",
        " {\n    padding: 0 16px 16px;\n  }\n\n  ",
        " {\n    padding: 0 32px 16px;\n  }\n"
    ]);
    RankingContents_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}

var Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9568b70c-0"
})(RankingContents_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.media.with("mobile", "tablet");
}, function(param) {
    var hasSubCategory = param.hasSubCategory;
    return hasSubCategory && (0,styled_components_browser_esm/* css */.iv)(RankingContents_style_templateObject());
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.media.tablet;
});
var style_LNBWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9568b70c-1"
})(RankingContents_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.pc;
});
var StickyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-9568b70c-2"
})(RankingContents_style_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.media.with("mobile", "tablet");
}, function(param) {
    var sticky = param.sticky;
    return sticky && (0,styled_components_browser_esm/* css */.iv)(RankingContents_style_templateObject3());
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.media.tablet;
});

;// CONCATENATED MODULE: ./src/features/home/RankingContents/index.tsx











function RankingContents() {
    var stickyRef = (0,react.useRef)(null);
    var router = (0,next_router.useRouter)();
    var isDesktop = (0,useMedia/* default */.Z)().isDesktop;
    var defaultSelectedMenu = useGetMenuByParams();
    var ref = (0,react.useState)(defaultSelectedMenu), selectedMenu = ref[0], setSelectedMenu = ref[1];
    var ref1 = (0,react.useState)("TOTAL"), selectedSubCategoryId = ref1[0], setSelectedSubCategoryId = ref1[1];
    var industriesMenu = useGetCatetoryIndustriesMenu(selectedMenu);
    var entry = (0,useIntersectionObserver/* default */.Z)(stickyRef, {
        root: null,
        rootMargin: "-55px 0px 0px",
        threshold: 0
    });
    var handleClickSubCategory = function(subCategoryId) {
        var params = new URLSearchParams({
            selectedMenu: selectedMenu,
            subCategory: subCategoryId
        });
        setSelectedSubCategoryId(subCategoryId);
        router.replace({
            pathname: "/",
            search: params.toString()
        }, undefined, {
            scroll: false
        });
    };
    (0,react.useEffect)(function() {
        if (router.isReady) {
            setSelectedMenu(defaultSelectedMenu !== null && defaultSelectedMenu !== void 0 ? defaultSelectedMenu : "DALIY_VIEW_RANK");
        }
    }, [
        defaultSelectedMenu,
        router
    ]);
    (0,react.useEffect)(function() {
        var ref;
        setSelectedSubCategoryId((ref = router.query.subCategory) !== null && ref !== void 0 ? ref : "TOTAL");
    }, [
        router.query
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                ref: stickyRef
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Wrapper, {
                hasSubCategory: industriesMenu && industriesMenu.length > 0,
                children: router.isReady && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(StickyWrapper, {
                            sticky: !(entry === null || entry === void 0 ? void 0 : entry.isIntersecting),
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(style_LNBWrapper, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(home_LNB, {
                                        selectedMenu: selectedMenu,
                                        setSelectedMenu: setSelectedMenu
                                    })
                                }),
                                !isDesktop && industriesMenu && industriesMenu.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(SubCategoryTabs, {
                                    selectedMenuId: selectedSubCategoryId,
                                    menuList: industriesMenu,
                                    onClick: handleClickSubCategory
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(home_Ranking, {
                            selectedMenu: selectedMenu
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/hooks/query/jobdom/useRecentComment.ts


function useGetRecentComment() {
    return (0,index_production.useQuery)([
        "homeRecentComment"
    ], function() {
        return (0,fetch/* fetcher */._)("/api/main/board");
    });
}

// EXTERNAL MODULE: ./src/lib/styles/Theme/common.ts
var common = __webpack_require__(55153);
;// CONCATENATED MODULE: ./src/features/home/RecentComment/style.ts

function RecentComment_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 652px;\n  margin-left: 242px;\n\n  ",
        " {\n    width: 100%;\n    margin-left: 0;\n  }\n"
    ]);
    RecentComment_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function RecentComment_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 38.48px;\n  color: ",
        ";\n  text-align: left;\n\n  ",
        " {\n    font-size: ",
        ";\n  }\n"
    ]);
    RecentComment_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function RecentComment_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin-top: 20px;\n  border: 1px solid ",
        ";\n  border-radius: 4px;\n\n  ",
        " {\n    margin-top: 15px;\n  }\n\n  > * + * {\n    border-top: 1px solid ",
        ";\n  }\n"
    ]);
    RecentComment_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function RecentComment_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  height: 50px;\n  align-items: center;\n\n  font-size: ",
        ";\n  color: ",
        ";\n  font-weight: ",
        ";\n\n  ",
        " {\n    flex-wrap: wrap;\n    align-content: space-between;\n    padding: 20px 15px;\n    height: 98px;\n  }\n\n  > div {\n    text-align: left;\n  }\n"
    ]);
    RecentComment_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function RecentComment_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: ",
        ";\n  border-radius: 2px;\n  display: inline-block;\n  color: ",
        ";\n  font-size: ",
        ";\n  text-align: center;\n  height: 16px;\n  line-height: 16px;\n  padding: 0 8px;\n  margin-left: 9px;\n  position: relative;\n\n  > .arrow {\n    position: absolute;\n    right: 100%;\n    top: 4px;\n    transform: rotate(270deg);\n    height: 7px;\n    overflow: hidden;\n\n    &:after {\n      content: '';\n      margin-top: 4px;\n      background-color: ",
        ";\n      height: 7px;\n      width: 7px;\n      display: block;\n      border-top-right-radius: 30%;\n      transform: rotate(-55deg) skewX(-20deg);\n    }\n  }\n"
    ]);
    RecentComment_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function RecentComment_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  font-weight: ",
        ";\n\n  ",
        " {\n    padding: 0 30px;\n    flex: 0 0 160px;\n  }\n\n  ",
        " {\n    order: 1;\n    width: 135px;\n    margin-right: auto;\n  }\n"
    ]);
    RecentComment_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function RecentComment_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  overflow: hidden;\n  ",
        " {\n    flex: 1;\n    font-weight: 400;\n  }\n\n  > p {\n    ",
        "\n  }\n\n  ",
        " {\n    order: 4;\n    width: 100%;\n    font-size: ",
        ";\n  }\n"
    ]);
    RecentComment_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function RecentComment_style_templateObject7() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n\n  ",
        " {\n    flex: 0 0 120px;\n    padding: 0 20px;\n    margin-left: auto;\n  }\n\n  ",
        " {\n    order: 2;\n    max-width: 77px;\n    margin-right: 10px;\n    font-size: ",
        ";\n  }\n"
    ]);
    RecentComment_style_templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    flex: 0 0 115px;\n    padding-left: 20px;\n  }\n\n  ",
        " {\n    order: 3;\n    font-size: ",
        ";\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}


var RecentCommentWrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-43ed98e-0"
})(RecentComment_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.with("mobile", "tablet");
});
var RecentCommentHead = styled_components_browser_esm/* default.h2.withConfig */.ZP.h2.withConfig({
    componentId: "sc-43ed98e-1"
})(RecentComment_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.fontWeight.bold;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.H4;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.T1;
});
var RecentCommentList = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43ed98e-2"
})(RecentComment_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
});
var RecentCommentItemWrapper = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-43ed98e-3"
})(RecentComment_style_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.fontSize.B3;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
}, function(param) {
    var theme = param.theme;
    return theme.fontWeight.normal;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var ArrowBox = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43ed98e-4"
})(RecentComment_style_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
}, function(param) {
    var theme = param.theme;
    return theme.colors.magenta700;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.C2;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray400;
});
var CommentCompany = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43ed98e-5"
})(RecentComment_style_templateObject5(), (0,common/* ellipsis */.LH)(), function(param) {
    var theme = param.theme;
    return theme.fontWeight.bold;
}, function(param) {
    var theme = param.theme;
    return theme.media.with("tablet", "pc");
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var CommentSubject = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43ed98e-6"
})(RecentComment_style_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.media.pc;
}, (0,common/* ellipsis */.LH)(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.B2;
});
var CommentName = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43ed98e-7"
})(RecentComment_style_templateObject7(), (0,common/* ellipsis */.LH)(), function(param) {
    var theme = param.theme;
    return theme.media.with("tablet", "pc");
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.C1;
});
var CommentDate = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-43ed98e-8"
})(_templateObject8(), function(param) {
    var theme = param.theme;
    return theme.media.with("tablet", "pc");
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.C1;
});

;// CONCATENATED MODULE: ./src/features/home/RecentComment/LoadingItem/style.ts

function LoadingItem_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 100%;\n  height: 50px;\n  align-items: center;\n\n  ",
        " {\n    flex-wrap: wrap;\n    align-content: space-between;\n    padding: 20px 15px;\n    height: 98px;\n  }\n\n  > div {\n    text-align: left;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    :after {\n      background-color: ",
        ";\n      display: block;\n      content: '';\n      height: 16px;\n    }\n\n    ",
        " {\n      :nth-child(2) {\n        padding-right: 25%;\n      }\n      :nth-child(4) {\n        padding-right: 30px;\n      }\n    }\n\n    ",
        " {\n      :nth-child(3) {\n        width: 100%;\n      }\n\n      :nth-child(4) {\n        width: 63px;\n      }\n    }\n  }\n"
    ]);
    LoadingItem_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var style_Wrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-84338e99-0"
})(LoadingItem_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray300;
}, function(param) {
    var theme = param.theme;
    return theme.media.pc;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});

;// CONCATENATED MODULE: ./src/features/home/RecentComment/LoadingItem/index.tsx



function LoadingItem() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(style_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentCompany, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentSubject, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentName, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentDate, {})
        ]
    });
}
/* harmony default export */ var RecentComment_LoadingItem = (LoadingItem);

// EXTERNAL MODULE: ./src/utils/date/getTimeAgo.ts
var getTimeAgo = __webpack_require__(35960);
;// CONCATENATED MODULE: ./src/features/home/RecentComment/RecentCommentItem/index.tsx




function RecentCommentItem(param) {
    var id = param.id, companyName = param.companyName, subject = param.subject, name = param.name, commentsCount = param.commentsCount, createdAt = param.createdAt;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: "/board/".concat(id),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentCommentItemWrapper, {
            "data-attribute-id": "home__board__click",
            "data-content-id": id,
            "data-company-name": companyName,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentCompany, {
                        children: companyName
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CommentSubject, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: subject
                            }),
                            commentsCount > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(ArrowBox, {
                                children: [
                                    commentsCount,
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "arrow"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentName, {
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CommentDate, {
                        children: (0,getTimeAgo/* default */.Z)(createdAt)
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var RecentComment_RecentCommentItem = (RecentCommentItem);

;// CONCATENATED MODULE: ./src/features/home/RecentComment/index.tsx









function RecentComment() {
    var ref = useGetRecentComment(), data = ref.data, status = ref.status;
    var recentCommentData = (0,react.useMemo)(function() {
        if (status !== "success") {
            return [];
        }
        return data.data.slice(0, 3);
    }, [
        data,
        status
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RecentCommentWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentCommentHead, {
                children: "새로운 JOB담"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentCommentList, {
                children: status === "loading" ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentComment_LoadingItem, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentComment_LoadingItem, {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentComment_LoadingItem, {})
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: recentCommentData.map(function(comment) {
                        return /*#__PURE__*/ (0,react.createElement)(RecentComment_RecentCommentItem, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, comment), {
                            key: "recent_comment_".concat(comment.id)
                        }));
                    })
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/Button/index.tsx + 2 modules
var Button = __webpack_require__(71664);
// EXTERNAL MODULE: ./src/components/ButtonClose/index.tsx + 1 modules
var ButtonClose = __webpack_require__(41616);
// EXTERNAL MODULE: ./src/lib/styles/Theme/colors.ts
var colors = __webpack_require__(18978);
// EXTERNAL MODULE: ./node_modules/framer-motion/dist/es/render/dom/motion.mjs + 173 modules
var motion = __webpack_require__(9172);
// EXTERNAL MODULE: ./src/components/Text/index.tsx + 1 modules
var Text = __webpack_require__(82734);
;// CONCATENATED MODULE: ./src/features/home/SalaryRankingNudge/style.ts

function SalaryRankingNudge_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: fixed;\n    width: 320px;\n    height: 268px;\n    left: 0;\n    bottom: 40px;\n\n    z-index: 10;\n\n    ",
        " {\n      width: 100%;\n      height: auto;\n\n      left: 0;\n      bottom: 0;\n      right: 0;\n    }\n  "
    ]);
    SalaryRankingNudge_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SalaryRankingNudge_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    background-color: #f0cfda;\n    box-shadow: 4px 4px 20px rgba(0, 0, 0, 0.15);\n    border-radius: 8px;\n    padding: 24px;\n    text-align: center;\n\n    ",
        " {\n      display: flex;\n      align-items: center;\n      height: 56px;\n      padding: 0 12px;\n      margin: 16px;\n    }\n  "
    ]);
    SalaryRankingNudge_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SalaryRankingNudge_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    img {\n      vertical-align: top;\n    }\n  "
    ]);
    SalaryRankingNudge_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SalaryRankingNudge_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    position: absolute;\n    right: 19px;\n    top: 19px;\n\n    cursor: pointer;\n\n    &::after {\n      content: '';\n      position: absolute;\n      left: 50%;\n      top: 50%;\n      transform: translate(-50%, -50%);\n      width: 350%;\n      height: 250%;\n    }\n  "
    ]);
    SalaryRankingNudge_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function SalaryRankingNudge_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    width: 272px;\n    height: 132px;\n\n    ",
        " {\n      width: 56px;\n      height: 56px;\n    }\n  "
    ]);
    SalaryRankingNudge_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function SalaryRankingNudge_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    display: block;\n    margin: 12px 0;\n    color: ",
        ";\n\n    ",
        " {\n      margin: 0;\n      margin-left: 4px;\n    }\n  "
    ]);
    SalaryRankingNudge_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function SalaryRankingNudge_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n    ",
        " {\n      display: flex;\n      flex: auto;\n      justify-content: flex-end;\n    }\n  "
    ]);
    SalaryRankingNudge_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}



var S = {
    Container: (0,styled_components_browser_esm/* default */.ZP)(motion/* motion.nav */.E.nav).withConfig({
        componentId: "sc-745e3765-0"
    })(SalaryRankingNudge_style_templateObject(), function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }),
    Wrapper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-745e3765-1"
    })(SalaryRankingNudge_style_templateObject1(), function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }),
    ImgWrapper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-745e3765-2"
    })(SalaryRankingNudge_style_templateObject2()),
    IconWrapper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-745e3765-3"
    })(SalaryRankingNudge_style_templateObject3()),
    Img: styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
        componentId: "sc-745e3765-4"
    })(SalaryRankingNudge_style_templateObject4(), function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }),
    Text: (0,styled_components_browser_esm/* default */.ZP)(Text/* default */.Z).withConfig({
        componentId: "sc-745e3765-5"
    })(SalaryRankingNudge_style_templateObject5(), function(param) {
        var theme = param.theme;
        return theme.colors.magenta900;
    }, function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    }),
    ButtonWrapper: styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
        componentId: "sc-745e3765-6"
    })(SalaryRankingNudge_style_templateObject6(), function(param) {
        var theme = param.theme;
        return theme.media.mobile;
    })
};

;// CONCATENATED MODULE: ./src/features/home/SalaryRankingNudge/index.tsx










function SalaryRankingNudge() {
    var router = (0,next_router.useRouter)();
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    var ref = (0,react.useState)(false), isActive = ref[0], setIsActive = ref[1];
    var salaryReportNudge = isServer/* isClient */.C ? localStorage.getItem("salaryReportNudge") : null;
    (0,react.useEffect)(function() {
        if (salaryReportNudge) {
            var now = dayjs_min_default()();
            var nudgeExpired = JSON.parse(salaryReportNudge);
            if (now.diff(nudgeExpired, "day") <= 0) {
                setIsActive(false);
            } else {
                localStorage.removeItem("salaryReportNudge");
            }
        } else {
            setIsActive(true);
        }
    }, []);
    var handleClose = function() {
        localStorage.setItem("salaryReportNudge", JSON.stringify(dayjs_min_default()().add(7, "day")));
        setIsActive(false);
    };
    var mobileVariants = {
        initial: {
            opacity: 0,
            willChange: "opacity"
        },
        animate: {
            opacity: 1,
            transition: {
                duration: 0.8
            },
            willChange: "opacity, transition"
        }
    };
    var desktopVariants = {
        initial: {
            opacity: 0,
            x: "100vw",
            willChange: "opacity, transition"
        },
        animate: {
            opacity: 1,
            x: "calc(100vw - (100% + 40px))",
            transition: {
                duration: 0.8,
                delay: 1.5
            },
            willChange: "opacity, transition"
        }
    };
    if (!isActive) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(S.Container, {
        variants: isMobile ? mobileVariants : desktopVariants,
        initial: "initial",
        animate: "animate",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(S.Wrapper, {
            children: [
                !isMobile && /*#__PURE__*/ (0,jsx_runtime.jsx)(S.IconWrapper, {
                    onClick: handleClose,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonClose/* default */.Z, {
                        size: 11,
                        color: colors/* default.magenta900 */.Z.magenta900
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(S.ImgWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("picture", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        srcSet: "https://image.wanted.co.kr/kreditjob/www/img-home-nudge-chart-m@2x.png 2x",
                                        media: "(max-width: 767px)"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("source", {
                                        srcSet: "https://image.wanted.co.kr/kreditjob/www/img-home-nudge-chart@2x.png 2x"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        src: "https://image.wanted.co.kr/kreditjob/www/img-home-nudge-chart.png",
                                        alt: ""
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(S.Text, {
                            typography: isMobile ? "midium120_B3" : "midium150_B1",
                            children: "연봉, 잘 받고 있는 걸까?"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(S.ButtonWrapper, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                size: isMobile ? "sm" : "lg",
                                variant: "magenta",
                                as: "a",
                                "data-attribute-id": "salaryRank__modal__click",
                                onClick: function() {
                                    router.push("/salaryreport/step");
                                },
                                children: "랭킹보기"
                            })
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var home_SalaryRankingNudge = (SalaryRankingNudge);

// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./src/components/Image/index.tsx + 1 modules
var Image = __webpack_require__(78982);
;// CONCATENATED MODULE: ./src/constant/banner.ts
var BANNERS = [
    {
        title: "원티드 AI",
        list_web: "이력서만 등록해도 나에게 딱 맞는 포지션 추천!",
        list_mobile: "이력서만 등록해도 나에게 딱 맞는\n포지션 추천!",
        side_web: "이력서만 등록해도 나에게\n딱 맞는 포지션 추천!",
        side_mobile: "이력서만 등록해도 나에게 딱 맞는\n포지션 추천!",
        image: "https://image.wanted.co.kr/kreditjob/www/banner_1.jpg",
        landingUrl: "https://www.wanted.co.kr/aiscore/resume",
        color: "#FBF0E7",
        eventId: "wanted_AI"
    },
    {
        title: "원티드 이력서",
        list_web: "합격률 높은 원티드 이력서, 쉽고 빠르게 작성해보세요",
        list_mobile: "합격률 높은 원티드 이력서, 쉽고\n빠르게 작성해보세요",
        side_web: "합격률 높은 원티드 이력서,\n쉽고 빠르게 작성해보세요",
        side_mobile: "합격률 높은 원티드 이력서, 쉽고\n빠르게 작성해보세요",
        image: "https://image.wanted.co.kr/kreditjob/www/banner_2.jpg",
        landingUrl: "https://www.wanted.co.kr/cv/intro",
        color: "#F4EFF6",
        eventId: "wanted_resume"
    },
    {
        title: "이직 준비",
        list_web: "요즘 핫한 이직 정보, 원티드에서 만나보세요",
        list_mobile: "요즘 핫한 이직 정보, 원티드에서\n만나보세요",
        side_web: "요즘 핫한 이직 정보,\n원티드에서 만나보세요",
        side_mobile: "요즘 핫한 이직 정보, 원티드에서\n만나보세요",
        image: "https://image.wanted.co.kr/kreditjob/www/banner_3.jpg",
        landingUrl: "https://www.wanted.co.kr/wdlist",
        color: "#E7F6F4",
        eventId: "wanted_position"
    },
    {
        title: "채용 고민 해결!",
        list_web: "우리 기업에 딱 맞는 인재, 원티드에서 찾아보세요",
        list_mobile: "우리 기업에 딱 맞는 인재, 원티드에서\n찾아보세요",
        side_web: "우리 기업에 딱 맞는 인재,\n원티드에서 찾아보세요",
        side_mobile: "우리 기업에 딱 맞는 인재, 원티드에서\n찾아보세요",
        image: "https://image.wanted.co.kr/kreditjob/www/banner_4.jpg",
        landingUrl: "https://www.wanted.co.kr/dashboard/welcome",
        color: "#EBF9EC",
        eventId: "wanted_company_dashboard"
    },
    {
        title: "이력서를 부탁해",
        list_web: "서류 합격률 높이고 싶다면? 원티드가 알려주는 이력서 작성 비법",
        list_mobile: "서류 합격률 높이고 싶다면? 원티드가\n알려주는 이력서 작성 비법",
        side_web: "서류 합격률 높이고 싶다면?\n원티드가 알려주는 이력서\n작성 비법",
        side_mobile: "서류 합격률 높이고 싶다면? 원티드가\n알려주는 이력서 작성 비법",
        image: "https://image.wanted.co.kr/kreditjob/www/banner_5.jpg",
        landingUrl: "https://www.wanted.co.kr/events/resume_contents",
        color: "#FFEFF4",
        eventId: "wanted_event_resume"
    },
    {
        title: "원티드긱스",
        list_web: "매칭부터 계약 관리까지, 프리랜서 전문 플랫폼",
        list_mobile: "매칭부터 계약 관리까지, 프리랜서\n전문 플랫폼",
        side_web: "매칭부터 계약 관리까지,\n프리랜서 전문 플랫폼",
        side_mobile: "매칭부터 계약 관리까지, 프리랜서\n전문 플랫폼",
        image: "https://image.wanted.co.kr/kreditjob/www/banner_7.jpg",
        landingUrl: "https://www.wanted.co.kr/gigs/experts",
        color: "#E9F2FE",
        eventId: "wanted_gigs"
    }, 
];

;// CONCATENATED MODULE: ./src/utils/common/shuffle.ts
/**
 * Knuth shuffle 알고리즘 활용해 배열을 섞는 함수
 * @param arr
 * @returns Array
 */ 
function shuffle(arr) {
    var newArr = (0,_to_consumable_array/* default */.Z)(arr);
    for(var i = newArr.length - 1; i > 0; i--){
        if (i % 2 === 0) {
            continue;
        }
        var randIndex = Math.floor(Math.random() * (i + 1));
        var temp = newArr[i];
        newArr[i] = newArr[randIndex];
        newArr[randIndex] = temp;
    }
    return newArr;
}

;// CONCATENATED MODULE: ./src/features/home/SideBanner/constants.ts
var SLICK_SETTING = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true
};

// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
;// CONCATENATED MODULE: ./src/features/home/SideBanner/style.ts

function SideBanner_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: auto;\n  height: auto;\n  text-align: center;\n\n  ",
        " {\n    width: 210px;\n    height: 358px;\n  }\n\n  .side-slider {\n    width: 100%;\n    text-align: center;\n    position: absolute;\n    padding: 0;\n    bottom: 18px;\n  }\n\n  .side-slider li:not(:last-child) {\n    margin-right: 7px;\n  }\n  .side-slider li {\n    position: relative;\n    display: inline-block;\n    cursor: pointer;\n    padding: 0;\n  }\n\n  .side-slider li button {\n    display: block;\n    line-height: 0;\n    padding: 0;\n    cursor: pointer;\n    color: transparent;\n    border: 0;\n    outline: 0;\n    background: 0 0;\n  }\n\n  .side-slider li button:before {\n    position: absolute;\n    content: '';\n    top: 0;\n    left: 0;\n    width: 8px;\n    height: 8px;\n    text-align: center;\n    background: #c4c4c4;\n    border-radius: 50px;\n  }\n\n  .side-slider li.slick-active {\n    width: 42px;\n  }\n\n  .side-slider li.slick-active button:before {\n    background: #666;\n    width: 42px;\n  }\n"
    ]);
    SideBanner_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function SideBanner_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-weight: ",
        ";\n  font-size: ",
        ";\n  line-height: 1.5;\n  color: ",
        ";\n"
    ]);
    SideBanner_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function SideBanner_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  white-space: pre-wrap;\n  font-weight: ",
        ";\n  font-size: ",
        ";\n"
    ]);
    SideBanner_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function SideBanner_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  display: inline-block;\n  line-height: 1.5;\n  border-radius: 4px;\n  background: ",
        ";\n  height: 305px;\n  display: block;\n  text-decoration: none;\n\n  width: 210px;\n  height: 358px;\n  text-align: left;\n  padding: 30px 0 18px 0;\n\n  & ",
        " {\n    margin-bottom: 4px;\n    padding: 0 20px;\n  }\n\n  & ",
        " {\n    margin-bottom: 18px;\n    padding: 0 20px;\n  }\n\n  & img {\n    width: 208px;\n    height: 185px;\n  }\n\n  ",
        " {\n    width: auto;\n    height: 305px;\n    text-align: center;\n\n    & > ",
        " {\n      margin-bottom: 5px;\n    }\n\n    & > img {\n      width: 168px;\n      height: 150px;\n      margin: auto;\n    }\n  }\n"
    ]);
    SideBanner_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}


var SideBanner_style_Wrapper = (0,styled_components_browser_esm/* default */.ZP)(lib/* default */.Z).withConfig({
    componentId: "sc-23729ddd-0"
})(SideBanner_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.pc;
});
var style_Title = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-23729ddd-1"
})(SideBanner_style_templateObject1(), function(param) {
    var theme = param.theme;
    return theme.fontWeight.bold;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.T1;
}, function(param) {
    var theme = param.theme;
    return theme.colors.gray900;
});
var SubTitle = styled_components_browser_esm/* default.p.withConfig */.ZP.p.withConfig({
    componentId: "sc-23729ddd-2"
})(SideBanner_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.fontWeight.normal;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.B3;
});
var SideBannerWrapper = styled_components_browser_esm/* default.a.withConfig */.ZP.a.withConfig({
    componentId: "sc-23729ddd-3"
})(SideBanner_style_templateObject3(), function(props) {
    return props.background;
}, style_Title, SubTitle, function(param) {
    var theme = param.theme;
    return theme.media.with("tablet", "mobile");
}, SubTitle);

;// CONCATENATED MODULE: ./src/features/home/SideBanner/index.tsx












function SideBanner() {
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    var shuffleBanners = (0,react.useMemo)(function() {
        return shuffle(BANNERS);
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SideBanner_style_Wrapper, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, SLICK_SETTING), {
        dotsClass: "side-slider",
        children: shuffleBanners.map(function(banner) {
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(SideBannerWrapper, {
                "data-attribute-id": "home__banner__click",
                "data-banner-type": banner.eventId,
                "data-banner-location": "right",
                background: banner.color,
                target: "_blank",
                href: banner.landingUrl,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(style_Title, {
                        children: banner.title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubTitle, {
                        children: isMobile ? banner.side_mobile : banner.side_web
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Image/* default */.Z, {
                        src: banner.image,
                        alt: banner.title,
                        width: 420
                    })
                ]
            }, "banner_slider_".concat(banner.eventId));
        })
    }));
}
/* harmony default export */ var home_SideBanner = (SideBanner);

// EXTERNAL MODULE: ./src/components/Autosuggest/index.tsx + 1 modules
var Autosuggest = __webpack_require__(4572);
// EXTERNAL MODULE: ./src/components/Autosuggest/helper.tsx
var Autosuggest_helper = __webpack_require__(93124);
;// CONCATENATED MODULE: ./src/features/home/TopBanner/BannerText/constants.ts
var constants_SLICK_SETTING = {
    dots: false,
    infinite: true,
    speed: 400,
    vertical: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    swipe: false
};

;// CONCATENATED MODULE: ./src/features/home/TopBanner/BannerText/style.ts

function BannerText_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  font-size: 36px;\n  color: ",
        ";\n  font-weight: ",
        ";\n  line-height: 40px;\n\n  ",
        " {\n    font-size: ",
        ";\n    line-height: 38px;\n    flex-direction: column;\n  }\n\n  .slick-slider {\n    margin-left: 5px;\n  }\n  .slick-slide {\n    width: auto !important;\n    float: none;\n    border: 0;\n  }\n"
    ]);
    BannerText_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var BannerText_style_Wrapper = styled_components_browser_esm/* default.h1.withConfig */.ZP.h1.withConfig({
    componentId: "sc-82d61ad5-0"
})(BannerText_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, function(param) {
    var theme = param.theme;
    return theme.fontWeight.bold;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.H4;
});

;// CONCATENATED MODULE: ./src/features/home/TopBanner/BannerText/index.tsx









function BannerText() {
    var isMobile = (0,useMedia/* default */.Z)().isMobile;
    if (isMobile) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerText_style_Wrapper, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    style: {
                        display: "flex"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "궁금했던"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants_SLICK_SETTING), {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "기업"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "연봉"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "채용"
                                })
                            ]
                        })),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            children: "정보,"
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "크레딧잡에서"
                })
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(BannerText_style_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "궁금했던"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants_SLICK_SETTING), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "기업"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "연봉"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: "채용"
                    })
                ]
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                children: "정보, 크레딧잡에서"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/Icon/Refresh.tsx




var Refresh = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 12,
        height: 16,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
            d: "M6 4v2l2.667-2.667L6 .667v2A5.332 5.332 0 0 0 .667 8c0 1.047.306 2.02.826 2.84l.974-.973A3.914 3.914 0 0 1 2 8c0-2.207 1.793-4 4-4Zm4.507 1.16-.974.973C9.827 6.693 10 7.327 10 8c0 2.207-1.793 4-4 4v-2l-2.667 2.667L6 15.333v-2A5.332 5.332 0 0 0 11.333 8c0-1.047-.306-2.02-.826-2.84Z",
            fill: "#000"
        })
    }));
};
/* harmony default export */ var Icon_Refresh = (Refresh);

;// CONCATENATED MODULE: ./src/hooks/query/home/useRealTimeList.ts


function useGetRealTimeList() {
    return (0,index_production.useQuery)([
        "homeRealTime"
    ], function() {
        return (0,fetch/* fetcher */._)("/api/company/realTime");
    });
}

;// CONCATENATED MODULE: ./src/features/home/TopBanner/Realtime/hooks.ts


function useGetSlicedList() {
    var ref = useGetRealTimeList(), data = ref.data, status = ref.status, refetch = ref.refetch;
    var slicedList = (0,react.useMemo)(function() {
        if (status !== "success") {
            return [];
        }
        return data.realTime.slice(0, 4);
    }, [
        data,
        status
    ]);
    return {
        slicedList: slicedList,
        status: status,
        refetch: refetch
    };
}

;// CONCATENATED MODULE: ./src/features/home/TopBanner/Realtime/style.ts

function Realtime_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  width: 580px;\n  margin: 0 auto;\n  margin-top: 22px;\n  padding-left: 19px;\n\n  ",
        " {\n    width: 335px;\n    margin-top: 18px;\n  }\n\n  & > dt {\n    font-size: ",
        ";\n    font-weight: ",
        ";\n    color: ",
        ";\n    height: 20px;\n    line-height: 13px;\n\n    & > button {\n      width: 20px;\n      height: 20px;\n      background-color: rgba(244, 244, 244, 0.3);\n      border-radius: 2px;\n      display: inline-block;\n      border: none;\n      padding: 0;\n      text-align: center;\n      margin-left: 8px;\n    }\n  }\n\n  & > dd > ul {\n    display: flex;\n    margin-left: 7px;\n\n    & > li {\n      width: 120px;\n      line-height: 17px;\n\n      & > a {\n        color: ",
        ";\n        text-align: center;\n        width: 100px;\n        display: inline-block;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        white-space: nowrap;\n        font-size: 14px;\n      }\n\n      ",
        " {\n        display: none;\n        &:nth-of-type(1),\n        &:nth-of-type(2) {\n          display: block;\n        }\n      }\n    }\n\n    & > li + li {\n      position: relative;\n      &::before {\n        content: '';\n        display: block;\n        position: absolute;\n        top: 4px;\n        left: 0px;\n        width: 1px;\n        height: 12px;\n        opacity: 0.2;\n        background-color: ",
        ";\n      }\n    }\n  }\n"
    ]);
    Realtime_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}

var RealTimeWrapper = styled_components_browser_esm/* default.dl.withConfig */.ZP.dl.withConfig({
    componentId: "sc-9cf71d37-0"
})(Realtime_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.fontSize.B3;
}, function(param) {
    var theme = param.theme;
    return theme.fontWeight.bold;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white100;
});

;// CONCATENATED MODULE: ./src/features/home/TopBanner/Realtime/index.tsx





function RealTime() {
    var ref = useGetSlicedList(), slicedList = ref.slicedList, refetch = ref.refetch;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RealTimeWrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("dt", {
                children: [
                    "실시간",
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        type: "button",
                        onClick: function() {
                            return refetch();
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon_Refresh, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                    children: slicedList.map(function(data, index) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/company/".concat(data.PK_NM_HASH),
                                title: decodeURI(data["CMPN_NM"]),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    "data-attribute-id": "company__search__click",
                                    "data-search-type": "실시간검색",
                                    "data-search-value": data["CMPN_NM"],
                                    children: decodeURI(data["CMPN_NM"])
                                })
                            })
                        }, index);
                    })
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/features/home/TopBanner/style.ts

function TopBanner_style_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  position: relative;\n  z-index: 2;\n  background: #160f30;\n  background-image: url('/images/main-pc-banner-bg.jpg');\n  background-position-x: 50%;\n  background-size: 2400px 330px;\n  background-repeat: no-repeat;\n  height: 330px;\n  width: 100%;\n  padding-top: 87px;\n  transform: translateX(-50%);\n  margin-left: 50%;\n\n  ",
        " {\n    width: 100%;\n  }\n  ",
        " {\n    background-image: url('/images/main-mobile-banner-bg.jpg');\n    height: 280px;\n    background-size: 1534px 280px;\n    padding-top: 50px;\n  }\n\n  /* SearchBox 공통 컴퍼넌트 스타일 커스텀 */\n  & > .search-box-wrapper {\n    width: 580px;\n    margin: 0 auto;\n    float: none;\n    margin-top: 20px;\n    padding: 0 24px;\n    height: 50px;\n    background: ",
        ";\n    box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.5);\n    border-radius: 60px;\n    position: relative;\n    display: flex;\n    align-items: center;\n\n    ",
        " {\n      width: 350px;\n      height: 48px;\n    }\n  }\n"
    ]);
    TopBanner_style_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function TopBanner_style_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n      border-radius: 25px 25px 0px 0px;\n      filter: drop-shadow(4px 4px 20px rgba(0, 0, 0, 0.15));\n    "
    ]);
    TopBanner_style_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function TopBanner_style_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 580px;\n  height: 50px;\n  position: relative;\n  display: flex;\n  border-radius: 25px;\n  border: none;\n  padding: 0 28px;\n  cursor: pointer;\n  align-items: center;\n  background: ",
        ";\n  margin: 0 auto;\n  margin-top: 20px;\n\n  ",
        "\n\n  > span {\n    margin-right: 24px;\n    display: flex;\n    align-items: center;\n\n    img {\n      width: 19px;\n      height: 19px;\n    }\n  }\n\n  ",
        " {\n    width: 343px;\n  }\n"
    ]);
    TopBanner_style_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function TopBanner_style_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  position: unset;\n"
    ]);
    TopBanner_style_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function TopBanner_style_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        ""
    ]);
    TopBanner_style_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function TopBanner_style_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  background: none;\n  border: none;\n  outline: none;\n\n  ",
        "\n"
    ]);
    TopBanner_style_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function TopBanner_style_templateObject6() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  border: none;\n  border-top: 1px solid ",
        ";\n  border-radius: 0px 0px 25px 25px;\n  box-shadow: none;\n"
    ]);
    TopBanner_style_templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}


var TopBanner_style_Wrapper = styled_components_browser_esm/* default.section.withConfig */.ZP.section.withConfig({
    componentId: "sc-dce49c7f-0"
})(TopBanner_style_templateObject(), function(param) {
    var theme = param.theme;
    return theme.media.tablet;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var InputWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-dce49c7f-1"
})(TopBanner_style_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.colors.white100;
}, function(param) {
    var isSearching = param.isSearching;
    return isSearching && (0,styled_components_browser_esm/* css */.iv)(TopBanner_style_templateObject1());
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
});
var inlineCss = (0,styled_components_browser_esm/* css */.iv)(TopBanner_style_templateObject3());
var inputCss = (0,styled_components_browser_esm/* css */.iv)(TopBanner_style_templateObject4());
var Input = styled_components_browser_esm/* default.input.withConfig */.ZP.input.withConfig({
    componentId: "sc-dce49c7f-2"
})(TopBanner_style_templateObject5(), (0,helper/* getFontStyle */.p)("midium150_B1"));
var listCss = (0,styled_components_browser_esm/* css */.iv)(TopBanner_style_templateObject6(), function(param) {
    var theme = param.theme;
    return theme.colors.gray600;
});

;// CONCATENATED MODULE: ./src/features/home/TopBanner/index.tsx









function TopBanner() {
    var router = (0,next_router.useRouter)();
    var ref = (0,Autosuggest_helper/* useAutosuggest */.U)(), isSearching = ref.isSearching, handleOpenSuggest = ref.handleOpenSuggest;
    var ref1 = (0,react.useState)(null), ref2 = ref1[0], setRef = ref1[1];
    var ref3 = (0,react.useState)({
        PK_NM_HASH: "",
        location: "",
        locationCode: "",
        name: ""
    }), value = ref3[0], setValue = ref3[1];
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(TopBanner_style_Wrapper, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BannerText, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(InputWrapper, {
                isSearching: isSearching && !!ref2,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                            src: "/images/search.png",
                            alt: "search-icon"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Autosuggest/* default */.Z, {
                        value: value,
                        isForm: true,
                        setValue: function(company) {
                            return setValue(company);
                        },
                        handleChange: function(value, type, query) {
                            router.push("/company/".concat(value.PK_NM_HASH));
                            handleOpenSuggest(false);
                            (0,thirdPartyEvent/* setGtmDataLayer */.id)("search__enter", {
                                searchValue: query
                            });
                        },
                        ref: function(newRef) {
                            return setRef(newRef);
                        },
                        renderInput: /*#__PURE__*/ (0,jsx_runtime.jsx)(Input, {
                            placeholder: "기업을 검색해보세요.",
                            onChange: function() {
                                handleOpenSuggest(true);
                            },
                            onBlur: function() {
                                return handleOpenSuggest(false);
                            },
                            onFocus: function() {
                                return handleOpenSuggest(true);
                            }
                        }),
                        inlineCss: inlineCss,
                        listCss: listCss,
                        onSubmit: function(data, search) {
                            router.push("/company/".concat(data.PK_NM_HASH));
                            (0,thirdPartyEvent/* setGtmDataLayer */.id)("search__enter", {
                                searchValue: search
                            });
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RealTime, {})
        ]
    });
}
/* harmony default export */ var home_TopBanner = (TopBanner);

;// CONCATENATED MODULE: ./src/lib/styles/pages/home.ts

function home_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background: #fff;\n"
    ]);
    home_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function home_templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 100%;\n  padding-top: 56px;\n"
    ]);
    home_templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function home_templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  width: 1136px;\n  margin: 0 auto;\n  text-align: center;\n\n  ",
        " {\n    width: 100%;\n  }\n"
    ]);
    home_templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function home_templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: 0 30px;\n  padding-top: 80px;\n\n  ",
        " {\n    display: block;\n    gap: 0;\n    padding-top: 0;\n  }\n"
    ]);
    home_templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function home_templateObject4() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        " {\n    overflow: hidden;\n    margin: 60px 0 50px 0;\n    padding: 0 16px;\n  }\n\n  ",
        " {\n    padding: 0 32px;\n  }\n"
    ]);
    home_templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function home_templateObject5() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  margin: 80px 0 95px;\n\n  ",
        " {\n    margin: 0 0 60px;\n  }\n\n  ",
        " {\n    padding: 0 16px;\n  }\n\n  ",
        " {\n    padding: 0 32px;\n  }\n"
    ]);
    home_templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}

// import { Layout } from "~styles/layout";
var HomeGlobalStyle = (0,styled_components_browser_esm/* createGlobalStyle */.vJ)(home_templateObject());
var Root = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba110f58-0"
})(home_templateObject1());
var HomeLayout = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba110f58-1"
})(home_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.media.with("mobile", "tablet");
});
var BodyWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba110f58-2"
})(home_templateObject3(), function(param) {
    var theme = param.theme;
    return theme.media.with("mobile", "tablet");
});
var home_SideBannerWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba110f58-3"
})(home_templateObject4(), function(param) {
    var theme = param.theme;
    return theme.media.with("mobile", "tablet");
}, function(param) {
    var theme = param.theme;
    return theme.media.tablet;
});
var home_RecentCommentWrapper = styled_components_browser_esm/* default.div.withConfig */.ZP.div.withConfig({
    componentId: "sc-ba110f58-4"
})(home_templateObject5(), function(param) {
    var theme = param.theme;
    return theme.media.with("mobile", "tablet");
}, function(param) {
    var theme = param.theme;
    return theme.media.mobile;
}, function(param) {
    var theme = param.theme;
    return theme.media.tablet;
});

;// CONCATENATED MODULE: ./src/pages/index.tsx










var Home = function() {
    (0,react.useEffect)(function() {
        (0,thirdPartyEvent/* setGtmDataLayer */.id)("home__view");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(RenderOnClient/* default */.Z, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HomeGlobalStyle, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_TopBanner, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(HomeLayout, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(BodyWrapper, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(RankingContents, {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_SideBannerWrapper, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(home_SideBanner, {})
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(home_RecentCommentWrapper, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(RecentComment, {})
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(home_SalaryRankingNudge, {})
        ]
    });
};
/* harmony default export */ var pages = (Home);


/***/ }),

/***/ 35960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getTimeAgo; }
/* harmony export */ });
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27484);
/* harmony import */ var dayjs__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(dayjs__WEBPACK_IMPORTED_MODULE_0__);

function getTimeAgo(value) {
    var now = dayjs__WEBPACK_IMPORTED_MODULE_0___default()();
    var date = dayjs__WEBPACK_IMPORTED_MODULE_0___default()(value);
    if (Math.abs(date.diff(now, "week", true)) > 1) {
        return date.format("YYYY-MM-DD");
    }
    if (Math.abs(date.diff(now, "second", true)) < 60) {
        return "".concat(Math.abs(date.diff(now, "second")), "초 전");
    }
    if (Math.abs(date.diff(now, "minute", true)) < 60) {
        return "".concat(Math.abs(date.diff(now, "minute")), "분 전");
    }
    if (Math.abs(date.diff(now, "hour", true)) < 24) {
        return "".concat(Math.abs(date.diff(now, "hour")), "시간 전");
    }
    return "".concat(Math.abs(date.diff(now, "day")), "일 전");
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [286,842,774,888,179], function() { return __webpack_exec__(48312); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);